import { useSelector } from 'react-redux';
import { resolveMenuItems } from '@milanote/roma/application';
import { ImMNElement } from '../../../../../../../common/elements/elementModelTypes';
import { useTranslator } from '../../../../../../components/i18n/useTranslator';
import { insertMenuConfig, InsertMenuContext } from './insertMenuPopupConfig';
import { userLocalePreferenceSelector } from '../../../../../../user/currentUserSelector';

type InsertMenuActions = Pick<
    InsertMenuContext,
    'insertEmoji' | 'insertDividerLine' | 'insertBoardLink' | 'insertMention'
>;

type UseInsertMenuNodesProps = {
    element?: ImMNElement;
    actions: InsertMenuActions;
};

const useInsertMenuNodes = ({ element, actions }: UseInsertMenuNodesProps) => {
    const translate = useTranslator('toolbar', 'tools.editing.insertMenu') as (localeKey: string) => string;
    const locale: string = useSelector(userLocalePreferenceSelector);

    const context: InsertMenuContext = {
        translate,
        locale,
        element,
        ...actions,
    };

    return resolveMenuItems(insertMenuConfig, context);
};

export default useInsertMenuNodes;
